import React from "react";
import "./GameHeroSection.css";
import "../Gamecommon.css";
import gameimg1 from "../gameassets/gameimg1.png";

export default function GameHeroSection() {
  return (
    <div id="gamehero" className="gamemainclass">
      <div className="left">
        <h1>Game Development Services</h1>
        <h3>Get Creative Minds Behind Your Game Vision</h3>
        <p>
          Bastionex is a game development company where storytelling, innovation, and technology converge to create unforgettable gaming experiences. From concept art and design to full-scale development and live operations, our end-to-end services ensure your game captivates players, drives engagement, and achieves lasting success.
        </p>
      </div>
      <div className="right">
        <div className="image">
          <img src={gameimg1} alt="error" />
        </div>
      </div>
    </div>
  );
}
